import { render, staticRenderFns } from "./AdminOrdersComponent.vue?vue&type=template&id=27592874"
import script from "./AdminOrdersComponent.vue?vue&type=script&lang=js"
export * from "./AdminOrdersComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminOrdersComponent.vue?vue&type=style&index=0&id=27592874&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports